const FixMegaMenuPosition = () => {
  const menus = document.querySelectorAll('.header__nav__list-item');
  const header = document.querySelector('header');
  const CLOSE_DELAY_MS = 1000;

  if (!header) return;
  const getHeaderHeight = () => header.offsetHeight || 0;

  function onAriaExpandedChange(el, callback) {
    let lastValue = el.getAttribute('aria-expanded');
    const observer = new MutationObserver(mutations => {
      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'aria-expanded') {
          const newValue = el.getAttribute('aria-expanded');
          if (newValue !== lastValue) {
            callback(newValue, lastValue);
            lastValue = newValue;
          }
        }
      }
    });
    observer.observe(el, { attributes: true });
    return observer;
  }

  const positionAll = () => {
    const headerHeight = getHeaderHeight();
    menus.forEach(menu => {
      const megamenu = menu.querySelector('.header__linklist-images-wrapper');
      if (megamenu) {
        megamenu.style.top = `${headerHeight}px`;
      }
    });
  };
  positionAll();
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(positionAll, 100);
  });

  menus.forEach(menu => {
    const megamenu = menu.querySelector('.header__linklist-images-wrapper');
    if (!megamenu) return;

    let hideTimeout = null;

    const showMenu = () => {
      clearTimeout(hideTimeout);
      megamenu.style.top = `${getHeaderHeight()}px`;
      megamenu.style.display = 'flex';
      megamenu.style.justifyContent = 'center';
      megamenu.classList.add('visible');
    };

    const hideMenu = () => {
      megamenu.style.display = 'none';
      megamenu.classList.remove('visible');
    };

    const scheduleHide = () => {
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        hideMenu();
      }, CLOSE_DELAY_MS);
    };

    onAriaExpandedChange(menu, (newVal) => {
      if (newVal === 'true') {
        showMenu();
      } else {
        scheduleHide();
      }
    });

    megamenu.addEventListener('mouseenter', () => {
      clearTimeout(hideTimeout);
    });
    megamenu.addEventListener('mouseleave', () => {
      scheduleHide();
    });
  });
};

window.addEventListener('DOMContentLoaded', FixMegaMenuPosition);
